import * as Yup from 'yup';

export type CruiseSaleGuestType = {
  isSelected: boolean;
  preferences: any[];
  id: string;
  guestId: string;
  guestName: string;
};

export type CruiseSaleDetailType = {
  isSelected: boolean;
  cruiseRoomNumber: string;
  deck: string;
  basicFare: number;
  portCharge: number;
  tax: number;
  tipping: number;
  description: string;
  id: string;
  guestId: string;
  guestName: string;
  cruiseRoomId: string;
};

export type CruiseSaleAddOnsType = {
  isSelected: boolean;
  guestId: string;
  description: string;
  price: number;
  id: string;
};

export type CruiseSaleType = {
  id: string;
  cruiseId: string;
  cruiseShipId: string;
  bookingCode?: string | null;
  startedAt: Date;
  endedAt: Date;
  route: string;
  isGroupedPrice: boolean;
  reminder: boolean;
  reminderDate?: Date | null;
  reminderDescription?: string | null;
  cruiseSaleGuests: CruiseSaleGuestType[];
  cruiseSaleDetails: CruiseSaleDetailType[];
  cruiseSaleAddOns: CruiseSaleAddOnsType[];
  cruiseRooms: { id: string; label: string }[];
};

export type CruiseRescheduleFormType = {
  cruiseSales: CruiseSaleType[];
  transactionAt: Date;
  invoiceNumber?: string;
  customer?: string;
  total: number;
};

export const CruiseRescheduleSchema = Yup.object()
  .shape({
    transactionAt: Yup.date().nullable().required(),
    invoiceNumber: Yup.string().strip(true),
    customer: Yup.string().strip(true),
    cruiseSales: Yup.array()
      .of(
        Yup.object({
          id: Yup.string().required(),
          cruiseId: Yup.string().nullable().required(),
          bookingCode: Yup.string().nullable().notRequired(),
          startedAt: Yup.date().nullable().required(),
          endedAt: Yup.date().nullable().required(),
          route: Yup.string().nullable().required(),
          isGroupedPrice: Yup.boolean(),
          reminder: Yup.boolean(),
          reminderDate: Yup.date().nullable(),
          reminderDescription: Yup.string().nullable(),
          cruiseSaleGuests: Yup.array()
            .of(
              Yup.object({
                id: Yup.string().required(),
                guestId: Yup.string().nullable().required(),
              }),
            )
            .required(),
          cruiseSaleDetails: Yup.array()
            .of(
              Yup.object({
                cruiseRoomNumber: Yup.string().nullable().required(),
                deck: Yup.string().required(),
                basicFare: Yup.number()
                  .transform((value) => (isNaN(value) ? undefined : value))
                  .min(0)
                  .required(),
                portCharge: Yup.number()
                  .transform((value) => (isNaN(value) ? undefined : value))
                  .min(0)
                  .required(),
                tax: Yup.number()
                  .transform((value) => (isNaN(value) ? undefined : value))
                  .min(0)
                  .required(),
                tipping: Yup.number()
                  .transform((value) => (isNaN(value) ? undefined : value))
                  .min(0)
                  .required(),
                id: Yup.string().required(),
                guestId: Yup.string().nullable(),
              }),
            )
            .required(),
          cruiseSaleAddOns: Yup.array()
            .of(
              Yup.object({
                guestId: Yup.string().nullable().required(),
                description: Yup.string().nullable(),
                price: Yup.number()
                  .transform((value) => (isNaN(value) ? undefined : value))
                  .min(0)
                  .required(),
              }).required(),
            )
            .required(),
        }).required(),
      )
      .required(),
  })
  .required();
